import { Mobile } from '../../../mobile.setup';
import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const title = 'PAGE.MOBILE.END_USERS.OVERVIEW.TITLE';
const path = 'overview';
const parent = Mobile.pages.endUsers;

const res = [
  'editInfo',
  'lines.viewInfo',
  'lines.add',
  'lines.sendMessage',
  'lines.phoneNumber',
  'lines.simSwap',
  'plans.apply',
  'plans.delete',
  'subscriptions.create',
  'subscriptions.view',
  'subscriptions.actions',
  'subscriptions.actions.renew',
  'subscriptions.actions.pause',
  'subscriptions.actions.resume',
  'subscriptions.actions.edit',
  'subscriptions.actions.uploadAttachments',
  'subscriptions.actions.cancel',
  'subscriptions.actions.viewHistory',
  'activateLine',
  'activateLine.lineType',
  'activateLine.plan',
];

export const MobileEndUsersOverviewTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
